export default __webpack_public_path__ + "static/media/background.39044851.jpg";